module.exports = __webpack_public_path__ + "img/About machinery cloud platform.0eec2344.png";